// 登录渠道与设备类别分别处理：扫码使用网站凭证，会话按设备隔离。
export function getWebLoginPlatform(device = navigator) {
  const ua = (device.userAgent || '').toLowerCase()
  const isTablet = /ipad|tablet|kindle|silk|playbook/.test(ua) ||
    (/android/.test(ua) && !/mobile/.test(ua)) ||
    (/macintosh/.test(ua) && Number(device.maxTouchPoints) > 1)
  if (isTablet) return 'tablet_web'
  return /mobile|android|iphone|ipod|blackberry|iemobile|opera mini/.test(ua)
    ? 'mobile_web' : 'pc_web'
}

export function resolveWechatLogin(savedType, device = navigator) {
  const webPlatform = getWebLoginPlatform(device)
  const isWechat = /micromessenger/i.test(device.userAgent || '')
  const isMp = savedType === 'mp' ||
    (!['pc_web', 'tablet_web', 'mobile_web'].includes(savedType) && isWechat)
  return { platform: isMp ? 'mp' : webPlatform, isMp: isMp ? '1' : '0' }
}
